import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ClientesService {
  TOKEN = localStorage.getItem('token');


  constructor(private http: HttpClient) { }
  
  eliminarCliente(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarCliente/", data, {headers});
  }

  getClientes(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getClientes/");
  }

  getClientesFiltro(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getClientesFiltro/", data);
  }

  getClientesFiltroText(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getClientesFiltroText/", data);
  }

  getClientesProduccion(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getClientesProduccion/");
  }

  getPagosReporte(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPagosReporte/");
  }

  getPagosGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPagosGrupo/", data);
  }

  getRegistros(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getRegistros/", data);
  }

  getRegistrosPorGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getRegistrosPorGrupo/", data);
  }

  getClientesProduccionFiltro(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getClientesProduccionFiltro/", data);
  }

  getPerfil(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPerfil/", data, {headers});
  }


  getProfile(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getProfile/",  {headers});
  }

  getFiestas(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getFiestas/");
  }

  getFiestaDetalle(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getFiestaDetalle/", data, {headers});
  }

  agregarFiesta(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFiesta/", data);
  }

  agregarDedicatoriaCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarDedicatoriaCliente/", data);
  }

  getPrecioAnillos(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPrecioAnillos/");
  }

  getAnillos(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getAnillos/");
  }

  getDetallePrecioAnillo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetallePrecioAnillo/", data, {headers});
  }

  updateAnilloPrecio(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateAnilloPrecio/", data);
  }

  agregarAnillo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarAnillo/", data);
  }

  getDetalleAnillo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetalleAnillo/", data, {headers});
  }

  updateAnillo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateAnillo/", data);
  }


  getViajes(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getViajes/");
  }

  getAnotaciones(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getAnotaciones/", data, {headers});
  }

  getDetalleViaje(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetalleViaje/", data, {headers});
  }

  updateViaje(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateViaje/", data);
  }

  updateFiesta(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateFiesta/", data);
  }
  
  agregarViajeCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarViajeCliente/", data, {headers});
  }

  agregarViaje(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarViaje/", data);
  }

  getPagos(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPagos/", data);
  }

  agregarPago(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPago/", data, {headers});
  }

  updateEstatus(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateEstatus/", data, {headers});
  }

  entregarPaquete(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/entregarPaquete/", data, {headers});
  }


  eliminarPago(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarPago/", data, {headers});
  }

  agregarCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarCliente/", data);
  }

  editarCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarCliente/", data);
  }

  updateCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateCliente/", data);
  }

  updateProfile(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateProfile/", data);
  }

  agregarClienteGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarClienteGrupo/", data);
  }

  agregarClienteGrupoV2(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarClienteGrupoV2/", data);
  }

  getPaqueteCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPaqueteCliente/", data);
  }

  getSolicitado(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getSolicitado/", data);
  }

  aplicarDescuento(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/aplicarDescuento/", data);
  }

  eliminarPlaca(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarPlaca/", data);
  }

  eliminarMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarMoldura/", data);
  }

  eliminarBoletosAdulto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarBoletosAdulto/", data);
  }

  eliminarBoletosNino(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarBoletosNino/", data);
  }

  agregarMolduraUsuario(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarMolduraUsuario/", data);
  }

  agregarPlacaUsuario(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPlacaUsuario/", data);
  }

  agregarPaqueteCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPaqueteCliente/", data);
  }
  
  getPlacas(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPlacas/");
  }

  getMostSelectedPlacas(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getMostSelectedPlacas/",  {headers});
  }

  getMolduras(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getMolduras/");
  }

  getMostSelectedMolduras(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getMostSelectedMolduras/");
  }

  getColores(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getColores/");
  }

  getPaqueteClienteSelected(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPaqueteClienteSelected/", data);
  }

  eliminarPaqueteCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarPaqueteCliente/", data);
  }

  eliminarPaqueteRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarPaqueteRegistrarme/", data);
  }

  eliminarPlacaRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarPlacaRegistrarme/", data);
  }

  eliminarMarcoRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarMarcoRegistrarme/", data);
  }

  eliminarColorRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarColorRegistrarme/", data);
  }

  eliminarDedicatoriaRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarDedicatoriaRegistrarme/", data);
  }

  agregarProductoCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarProductoCliente/", data);
  }

  agregarFondoMolduraCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFondoMolduraCliente/", data);
  }

  solicitarPaqueteRegistrarme(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/solicitarPaqueteRegistrarme/", data);
  }


  eliminarProductoCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarProductoCliente/", data);
  }

  eliminarColorUsuario(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarColorUsuario/", data);
  }

  eliminarDedicatoriaCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarDedicatoriaCliente/", data);
  }

  eliminarDescuentoCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarDescuentoCliente/", data);
  }

  eliminarFondoMolduraCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarFondoMolduraCliente/", data);
  }

  editarDedicatoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarDedicatoria/", data);
  }

  updateDedicatoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateDedicatoria/", data);
  }

  agregarDedicatoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarDedicatoria/", data);
  }

  eliminarAnilloCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarAnilloCliente/", data);
  }

  eliminarViajeCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarViajeCliente/", data);
  }

  agregarColorUsuario(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarColorUsuario/", data);
  }

  agregarAnotaciones(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarAnotaciones/", data);
  }

  agregarBoletosAdulto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarBoletosAdulto/", data);
  }

  agregarBoletosNino(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarBoletosNino/", data);
  }

  solicitarPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/solicitarPaquete/", data);
  }

  desolicitarCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/desolicitarCliente/", data);
  }


  agregarAnilloCliente(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarAnilloCliente/", data);
  }


  getDataUsuario(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    console.log(this.TOKEN)
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getDataUsuario/",  {headers});
  }

  agregarPaqueteClienteV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPaqueteClienteV2/", data, {headers});
  }

  agregarPaqueteClienteCatalogoV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPaqueteClienteCatalogoV2/", data, {headers});
  }

  agregarMolduraUsuarioV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarMolduraUsuarioV2/", data, {headers});
  }

  agregarColorUsuarioV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarColorUsuarioV2/", data, {headers});
  }


  agregarPlacaUsuarioV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPlacaUsuarioV2/", data, {headers});
  }

  agregarDedicatoriaClienteV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarDedicatoriaClienteV2/", data, {headers});
  }

  getPersonalizacionClienteV2(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/personalizacion-cliente-v2/", {headers});
  }

  seleccionarConfiguracionClienteV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/seleccionar-configuracion-cliente-v2/", data, {headers});
  }

  eliminarConfiguracionClienteV2(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminar-configuracion-cliente-v2/", data, {headers});
  }

  omitirDedicatoria(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/omitirDedicatoria/", data, {headers});
  }

  enviarPago(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/enviarPago/", data,  {headers});
  }


  reporteGrupos30():Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/reporteGrupos30/", {headers});
  }

  actualizarAvanceVideo():Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/actualizarAvanceVideo/", {headers});
  }

  getPaquetesGrupo(data:any):Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getPaquetesGrupo/", data, {headers});
  }

  agregarPaqueteClienteV3(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPaqueteClienteV3/", data, {headers});
  }

  getConfiguracionPaquete(data:any):Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getConfiguracionPaquete/", data, {headers});
  }

  getSeleccionesCliente(data:any):Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getSeleccionesCliente/", data, {headers});
  }

  agregarMolduraUsuarioV3(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarMolduraUsuarioV3/", data, {headers});
  }

  getViajesGrupoCliente(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getViajesGrupoCliente/", data, {headers});
  }
}

